import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";
import { fromUTC } from "../../../../utils/dateUtil";

const LogWO = ({ data }) => {
  const [logData, setLogData] = useState([]);
  const [logGeneral, setLogGeneral] = useState([]);
  const [approvalLog, setApprovalLog] = useState([]);

  useEffect(() => {
    if (data) {
      fetchWorkOrderLogs(data);
    } else {
      setLogGeneral([]);
    }
  }, [data]);

  const fetchWorkOrderLogs = async (workOrderId) => {
    try {
      const getLogsLink = masterAPI.workOrder.getLogs;
      const res = await axiosPrivate.get(`${getLogsLink}/${workOrderId}`);
      console.log(res.data);
      if (res.data.result) {
        setLogGeneral(res.data.result.workOrderLogList);
        setApprovalLog(res.data.result.workFlowApprovalHistoryList);
      } else {
        setLogGeneral([]);
        setApprovalLog([]);
      }
    } catch (error) {
      setLogGeneral([]);
      setApprovalLog([]);
      console.log(error, "workOrderLogError");
    }
  };
  const columns = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "createdDate",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
          >
            {cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-"}
          </Typography>
        );
    },
  },
    {
      Header: "User",
      accessor: "personName",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: cell.value === "Approved" ? "green" : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Workflow For",
      accessor: "workFlowFor",
    },
    {
      Header: "Workflow Level",
      accessor: "workFlowLevel",
    },
    {
      Header: "Workflow Name",
      accessor: "workFlowName",
    },
  ];

  const columnsGeneral = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "createdDate",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
          >
            {cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-"}
          </Typography>
        );
      },
    },

    {
      Header: "User",
      accessor: "modifiedByName",
    },
    // {
    //   Header: "Log Type",
    //   accessor: "logtype",
    // },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color:
                cell.value === "COM" ||
                cell.value === "OPEN" ||
                cell.value === "APPR"
                  ? "green"
                  : cell.value === "INPRG"
                    ? "orange"
                    : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Log
        </Typography>
      </Box>
      <Paper sx={{ p: 1 }}>
        <Typography
          sx={{
            color: color.sideTitle2Color,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideFontWeight,
          }}
        >
          General Log
        </Typography>
        <Divider sx={{ m: "0.5rem 0 0.5rem 0" }} />
        <NormalTable columns={columnsGeneral} data={logGeneral} />
      </Paper>
      <Paper sx={{ p: 1 }}>
        <Typography
          sx={{
            color: color.sideTitle2Color,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideFontWeight,
          }}
        >
          Approval Log
        </Typography>
        <Divider sx={{ m: "0.5rem 0 0.5rem 0" }} />
        <NormalTable columns={columns} data={approvalLog} />
      </Paper>
    </Box>
  );
};

export default LogWO;
